import { observable, action, makeObservable } from 'mobx';

import useStores from 'jsx/utils/hooks/useStores';
import openKustomerChat, {
  initiateKustomerChat,
} from 'jsx/utils/openKustomerChat';
import CONFIG from 'jsx/constants/config';

class KustomerChatStore {
  private readonly apiKey = CONFIG.keys.kustomerKey;

  private readonly brandId = CONFIG.keys.kustomerBrandId;

  private readonly scheduleId = CONFIG.keys.kustomerChatScheduleId;

  private patientId?: string;

  @observable
  wasEverOpened = false;

  @observable
  isOpening = false;

  constructor() {
    makeObservable(this);
  }

  @action
  open = async () => {
    if (!this.wasEverOpened && !this.isOpening && this.patientId) {
      this.setIsOpening(true);

      try {
        const { apiKey, brandId, scheduleId, patientId } = this;

        await openKustomerChat({
          apiKey,
          brandId,
          scheduleId,
          patientId,
        });

        this.setWasEverOpened(true);
      } finally {
        this.setIsOpening(false);
      }
    }
  };

  @action
  initialize = async (patientId: string) => {
    const { apiKey, brandId, scheduleId } = this;

    this.setPatientId(patientId);

    await initiateKustomerChat({
      apiKey,
      brandId,
      scheduleId,
      patientId,
    });
  };

  @action
  private setWasEverOpened(wasEverOpened: boolean): void {
    this.wasEverOpened = wasEverOpened;
  }

  @action
  private setIsOpening(isOpening: boolean): void {
    this.isOpening = isOpening;
  }

  private setPatientId(patientId: string): void {
    this.patientId = patientId;
  }
}

export const useKustomerChatStore = (): {
  kustomerChatStore: KustomerChatStore;
} => {
  const { kustomerChatStore } = useStores();

  return { kustomerChatStore };
};

export default KustomerChatStore;
